import { useState } from "react";
import { createRoot } from "react-dom/client";

import { AdminTools, type AdminToolsProps } from "components/admin-tools";
import { PolicyNotes } from "components/admin-tools/policy-notes";
import { PolicySearch } from "components/admin-tools/policy-search";
import { UserInput } from "components/admin-tools/user-input";

const AdminRoot = () => {
  const [adminDisplay, setAdminDisplay] = useState<
    AdminToolsProps["displaySettings"]
  >({
    showNotes: false,
    showPolicySearch: false,
    showUserInput: false,
  });
  function updateAdminDisplay(
    partial: Partial<AdminToolsProps["displaySettings"]>
  ) {
    setAdminDisplay((state) => ({ ...state, ...partial }));
  }

  return (
    <div>
      <AdminTools
        displaySettings={adminDisplay}
        setDisplaySettings={updateAdminDisplay}
      />
      {adminDisplay.showNotes && (
        <PolicyNotes onClose={() => updateAdminDisplay({ showNotes: false })} />
      )}
      {adminDisplay.showPolicySearch && (
        <PolicySearch
          onClose={() => updateAdminDisplay({ showPolicySearch: false })}
        />
      )}
      {adminDisplay.showUserInput && (
        <UserInput
          onClose={() => updateAdminDisplay({ showUserInput: false })}
        />
      )}
    </div>
  );
};

(async () => {
  const container = document.getElementById("admin-layer");
  if (!container) {
    console.error("no app element");
    return;
  }

  const root = createRoot(container);
  root.render(<AdminRoot />);
})();
